import { useState } from 'react'
import { createContainer } from 'unstated-next'

import { DragDropData, DragDropListsEvents, ItemProps, State } from '../dtos'

import { createNewItem, deleteItem, itemClick } from './actions'
import { useOptimisticRendering } from './useOptimisticRendering'
import { useOnDataChanged } from './useOnDataChanged'
import { useMoveItem } from './useMoveItem'

interface Components {
    ListHeader: React.ElementType
    Item?: React.ElementType<ItemProps>
    NewItem?: React.ElementType
    NewItemButton?: React.ElementType
}

export interface UseDragDropListsProps {
    classNameItem?: string
    components?: Components
    data: DragDropData
    serverEvents: DragDropListsEvents
    extraProps?: { [key: string]: any }
    options?: {
        showScrollbar?: boolean
    }
}

const useDragDropLists = (props: UseDragDropListsProps) => {
    const {
        classNameItem,
        components,
        data,
        extraProps,
        serverEvents,
        options
    } = props

    // if null, it's not optimistic. For now, it's an object for if I need to pass
    // more options in the future.
    const optimisticOptions = {}

    const [showNewItemListId, setShowNewItemListId] = useState<string>()
    const showScrollbar =
        options && options.showScrollbar !== undefined
            ? options.showScrollbar
            : false

    // Allows to keep creating new items.
    const toggleShowNewItem = (listId: string) => {
        setShowNewItemListId(listId)
    }

    const [state, setState] = useState<State>({
        items: {},
        itemsBasicProps: {},
        listOrder: [],
        lists: {},
        filter: { isFiltered: false, visibleItems: [] }
    })

    const { setOptimisticState } = useOptimisticRendering({
        data,
        setState
    })

    useOnDataChanged({
        data,
        state,
        onDataChangedServer: serverEvents?.onDataChanged
    })

    const { onDropItem, onDropList } = useMoveItem({
        onItemMoveServer: serverEvents?.onItemMove,
        optimisticOptions,
        setOptimisticState,
        setState,
        state
    })

    return {
        classNameItem,
        components,
        extraProps,
        onDropItem,
        onDropList,
        onItemClick: itemClick({
            onItemClickServer: serverEvents?.onItemClick
        }),
        onItemDelete: deleteItem({
            onItemDeleteServer: serverEvents?.onItemDelete,
            optimisticOptions,
            setState,
            setOptimisticState,
            state
        }),
        onSaveNewItemClicked: createNewItem({
            onNewItemAddServer: serverEvents?.onNewItemAdd,
            optimisticOptions,
            setOptimisticState,
            setState,
            state
        }),
        // setState,
        showNewItemListId,
        showScrollbar,
        state,
        toggleShowNewItem
    }
}

// @ts-ignore
export const DragDropListsContainer = createContainer(useDragDropLists)
